export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7524.6f2a4956.jpg";